import * as React from 'react';
import './batteryTracking.css';
import '../../index.css';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { getDatabase, ref, onValue} from "firebase/database";
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import { getAPI } from "../../common";

const db = getDatabase();
dayjs.extend(utc);


export default class BatteryTracking extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      batterysCheckedIn: [],
      pointless: 0,
      showNameModal: false,
      batteryID: null,
      newBatteryName: '',
      nextBatteryToUseName: 'BatteryHere',
      batteryInUseName: 'BatteryCurrent',
    }
    setInterval(() => {this.setState({pointless: this.state.pointless++})}, 1000);
    this.handleModalNameBattery = this.handleModalNameBattery.bind(this);
    this.handleModalNameBatterySubmit = this.handleModalNameBatterySubmit.bind(this);
    };

componentDidMount() {
  const firebaseChargingBatteryList = ref(db, "/CurrentChargingList");
  const firebaseNameRequests = ref(db, "/NameRequests");
  const firebaseBatteryNextUp = ref(db, "/BatteryNextUp");
  const firebaseBatteryInUse = ref(db, "/BatteryInUse");
  const firebaseBatteryNames = ref(db, "/BatteryNames");

  onValue(firebaseBatteryNextUp, (snapshot) => {
    let batteryName = 'BatteryHere';
    if (snapshot.val()) {
      batteryName = snapshot.val().BatteryNext;
    }
    this.setState({ nextBatteryToUseName: batteryName });
  });

  onValue(firebaseBatteryInUse, (snapshot) => {
    let batteryName = 'BatteryCurrent';
    if (snapshot.val()) {
      batteryName = snapshot.val();
    }
    this.setState({ batteryInUseName: batteryName });
  });

  onValue(firebaseChargingBatteryList, (snapshot) => {
  let batteryList = [];
  for(let battery in snapshot.val()) {
    let batteryName = 'Unknown Battery';
    console.log("Battery ID: ", snapshot.val()[battery].ID, 'Battery Start Charge:', snapshot.val()[battery].ChargingStartTime);
    onValue(firebaseBatteryNames, (nameSnapshot) => {
      if (nameSnapshot.val() && nameSnapshot.val()[snapshot.val()[battery].ID]) {
        console.log("Found Name for Battery ID: ", snapshot.val()[battery].ID, 'Name:', nameSnapshot.val()[snapshot.val()[battery].ID].name);
        batteryName = nameSnapshot.val()[snapshot.val()[battery].ID].name;

        batteryList.push({
          id: snapshot.val()[battery].ID,
          chargingStartTime: snapshot.val()[battery].ChargingStartTime,
          name: batteryName,
        });
      }

      else {
        batteryList.push({
          id: snapshot.val()[battery].ID,
          chargingStartTime: snapshot.val()[battery].ChargingStartTime,
          name: batteryName,
        });
      }
    });
  }
  this.setState({ batterysCheckedIn: batteryList });
  });


  onValue(firebaseNameRequests, (snapshot) => {
    let batteryID = '';
    if (snapshot.val()) {
      for (let request in snapshot.val()) {
        console.log("Name Request for Battery ID: ", snapshot.val()[request].ID);
        batteryID = snapshot.val()[request].ID;
      }
      this.setState({ showNameModal: true, batteryID});
    }
    else {
      this.setState({ showNameModal: false });
    }
  });

}

countUp(signInTime) {
    let totalSeconds = dayjs().utc().diff(dayjs(signInTime), 'seconds');
    let seconds = ((totalSeconds % 60 == NaN ? '0' : totalSeconds % 60) < 10 ? '0' + (totalSeconds % 60 == NaN ? '00' : totalSeconds % 60) :  (totalSeconds % 60 == NaN ? '0' : totalSeconds % 60));
    let minutes = ((Math.floor(Number((totalSeconds % 3600) / 60)) == NaN ? '0' : Math.floor(Number((totalSeconds %3600) / 60))) < 10 ? '0' + (Math.floor(Number((totalSeconds % 3600) / 60)) == NaN ? '0' : Math.floor(Number((totalSeconds %3600) / 60))) : (Math.floor(Number((totalSeconds % 3600) / 60)) == NaN ? '0' : Math.floor(Number((totalSeconds %3600) / 60))));
    let hours = ((Math.floor(Number(totalSeconds / 3600)) == NaN ? '0' : Math.floor(Number(totalSeconds / 3600))) < 10 ? '0' + (Math.floor(Number(totalSeconds / 3600)) == NaN ? '0' : Math.floor(Number(totalSeconds / 3600))) : (Math.floor(Number(totalSeconds / 3600)) == NaN ? '0' : Math.floor(Number(totalSeconds / 3600))));
    return `${hours}:${minutes}:${seconds}`;
}

getChargingBatteryList(batteryList) {
        return (
            <div>
                {batteryList.map(battery => (
                    <div key={battery.id} className='chargingBatteryItems'>
                        <div className='chargingBatteryItem'>{battery.name === 'Unknown Battery' ? battery.id : battery.name}</div>
                        <div className='chargingBatteryItem'>{this.countUp(battery.chargingStartTime)}</div>
                    </div>
                ))}
            </div>
        )
      }

  handleModalNameBattery() {
    this.setState({showNameModal: false})
  }

    handleModalNameBatterySubmit() {
    console.log('Here is the new name, DO SOMETHING WITH THIS', this.state.newBatteryName)

    axios.post(getAPI() + '/batteryTracking/batteryNameUpdate', { batteryID: this.state.batteryID, newBatteryName: this.state.newBatteryName })
    .then((response) => {
      console.log('Battery name updated successfully:', response.data);
    });

    this.setState({showNameModal: false})
  }

render(){
    return(
      <div className="fullScreen" style={{backgroundColor: "#262927"}}>
        <div className="centerItems">
          <div className="topBatteryToUse">
            <div>Next Available:</div> <div style={{color: "#7211cf"}}>{this.state.nextBatteryToUseName}</div>
          </div>
          <div className='middleRowSquares'>
            <div className='middleRowSquare'>
              <div className='middleRowSquareText'>Currently Charging</div>
              { this.state.batterysCheckedIn.length > 0 ? this.getChargingBatteryList(this.state.batterysCheckedIn) : <div>No Batteries Charging</div>}
            </div> 
            <div className='middleRowSquare'>
              <div className='middleRowSquareText'>Status</div>
              <div className='statusItem'> 
                <div className='statusItemLabel'>
                  Database
                </div>
                <div className='statusItemValue' style={{backgroundColor: true == true ? '#4caf50' : '#f44336'}}>
                </div>
              </div>
                 <div className='statusItem'> 
                <div className='statusItemLabel'>
                  Pi
                </div>
                <div className='statusItemValue' style={{backgroundColor: true == false ? '#4caf50' : '#f44336'}}>
                </div>
              </div>
                 <div className='statusItem'> 
                <div className='statusItemLabel'>
                  Ardunino 1
                </div>
                <div className='statusItemValue' style={{backgroundColor: true == false ? '#4caf50' : '#f44336'}}>
                </div>
              </div>
                 <div className='statusItem'> 
                <div className='statusItemLabel'>
                  Ardunino 2
                </div>
                <div className='statusItemValue' style={{backgroundColor: true == true ? '#4caf50' : '#f44336'}}>
                </div>
              </div>
            </div>
            <div className='middleRowSquare'>
              <div className='middleRowSquareText'>Currently Being Used</div>
              <div className='middleRowLargeText'>
                {this.state.batteryInUseName}
              </div>
            </div>
          </div>
          <div className='bottomButtonRow'>
            <Button className='bottomButton' style={{fontWeight: '800'}} variant="contained" size='large' color={'jackson'} onClick={this.handleModalNameBatterySubmit}>History</Button>
            <Button className='bottomButton' style={{fontWeight: '800'}} variant="contained" size='large' color={'jackson'} onClick={this.handleModalNameBattery}>Settings</Button>
          </div>
          <Modal className='modalScreen' open={(this.state.showNameModal)} onClose={this.handleModalNameBattery}>  
            <div className='modalContent'>
              <div>
              Battery Name Assignment
              </div>
               <div>
              Battery ID: {this.state.batteryID}
              </div>
              <div className='scoutingPageField'>
                <TextField
                fullWidth
                value={this.state.newBatteryName}
                label="Name"
                onChange={(e) => {
                    this.setState({newBatteryName: e.target.value});
                }}
                />
                </div>
              <Button className='matchScoutingButton' variant="contained" size='large' color={'signIn'} onClick={this.handleModalNameBatterySubmit}>Submit</Button>
              <Button className='matchScoutingButton' variant="contained" size='large' color={'signOut'} onClick={this.handleModalNameBattery}>Close</Button>
            </div>
          </Modal>
        </div>
      </div>
    )
}
}